import PhoneInput from 'react-phone-input-2';
import StepLayout from './StepLayout';
import { modalToggleStore, userFormStore } from '../../../store/Store';

const MIN_PHONE_DIGITS = 8;

const Profile3 = () => {
    const detailUserForm = userFormStore.useState((s) => s.detailUserForm);
    const phone = detailUserForm.phone || '';
    const valid = phone.length >= MIN_PHONE_DIGITS;

    const setPhone = (value) => {
        userFormStore.update((s) => {
            s.detailUserForm = { ...s.detailUserForm, phone: value };
        });
    };

    const openFourthPage = () => {
        modalToggleStore.update((s) => {
            s.profilePage = 4;
        });
    };

    return (
        <StepLayout
            title='What is your phone number?'
            primaryLabel='Continue'
            onPrimary={openFourthPage}
            primaryDisabled={!valid}
            hint={valid ? undefined : 'Enter your phone number to continue.'}
        >
            <label className='flow-field-label' htmlFor='profile-phone'>
                Phone number
            </label>
            <PhoneInput
                country='ca'
                value={phone}
                onChange={setPhone}
                inputProps={{
                    id: 'profile-phone',
                    name: 'phone',
                    autoComplete: 'tel',
                    'aria-describedby': 'profile-phone-use',
                }}
            />
            <h3 className='flow-step__section-title' id='profile-phone-use'>
                How will we use your phone number?
            </h3>
            <p>
                Communications will come from Parry Sound Fire and Rescue Department and will be
                restricted to notifications of burn bans and other important notices. Your phone
                number will not be used for promotional or marketing purposes or shared with third
                parties.
            </p>
        </StepLayout>
    );
};

export default Profile3;
